import { Kbd } from "./kbd"

function CmdCtrl(props: React.ComponentProps<typeof Kbd>) {
  const isMac =
    typeof navigator !== "undefined" &&
    navigator.platform?.toLowerCase().includes("mac")
  return <Kbd {...props}>{isMac ? "⌘" : "Ctrl"}</Kbd>
}

export { CmdCtrl }
